import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import { connect } from 'react-redux';

import PlayerWrapper from './player-wrapper';

import OverlayMemberOnlyMobile from 'widget/components/player-overlay/mobile/member-only';
import { pauseVideo } from 'widget/redux/client/actions/player/change-playback-status';


function getDependentProps(paused, isInFullscreen) {
  return {
    playAtFullScreen: true,
    showInitialOverlay: !isInFullscreen && paused,
  };
}

// TODO: Move to HOC PlayAtFullScreenOnly and use at components instead of nesting
// https://jira.wixpress.com/browse/VOD-209
@connect(
  null,
  () => ({
    pauseVideo,
  }),
)
export default class MobilePlayer extends React.Component {

  static propTypes = _.omit(PlayerWrapper.propTypes, [
    'mobileMode',
    'playAtFullScreen',
    'showInitialOverlay',
    'onPurchaseClick',
    'onSubscribeClick',
  ]);

  static defaultProps = {
    onFullScreenChanged: _.noop,
    onPlayStart: _.noop,
  };

  constructor(props) {
    super(props);

    this.state = {
      ...getDependentProps(props.paused, false),
      paused: props.paused,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { paused } = nextProps;
    const { isInFullScreen } = this.state;

    if (this.props.paused !== paused) {
      const newState = {
        ...getDependentProps(paused, isInFullScreen),
        paused,
      };

      // do not show overlay when in full screen (android case)
      if (paused && isInFullScreen) {
        newState.showInitialOverlay = false;
      }

      this.setState(newState);
    }
  }

  @autobind
  onPlayStart() {
    this.props.onPlayStart();

    this.setState(getDependentProps(false, true));
  }

  @autobind
  onFullScreenChanged(isInFullScreen) {
    this.props.onFullScreenChanged(isInFullScreen);

    let state = {
      isInFullScreen,
    };

    if (!isInFullScreen) {
      this.props.pauseVideo();
      const newPaused = true;

      state = {
        ...state,
        paused: newPaused,
        ...getDependentProps(newPaused, isInFullScreen),
      };
    }

    this.setState(state);
  }

  render() {
    const { playAtFullScreen, paused, showInitialOverlay } = this.state;
    const { memberOnlyOverlay } = this.props;

    const props = _.omit(this.props,
      'paused',
      'mobileMode',
      'playAtFullScreen',
      'onFullScreenChanged',
      'memberOnlyOverlay',
      'onPurchaseClick',
      'onSubscribeClick'
    );

    return (
      <PlayerWrapper {...props}
                     mobileMode
                     paused={paused}
                     playAtFullScreen={playAtFullScreen}
                     showInitialOverlay={showInitialOverlay}
                     onPlayStart={this.onPlayStart}
                     onFullScreenChanged={this.onFullScreenChanged}
                     memberOnlyOverlay={memberOnlyOverlay || <OverlayMemberOnlyMobile />} />
    );
  }

}



// WEBPACK FOOTER //
// ./src/widget/components/players/mobile-player.js